import React, {useCallback, useState} from 'react';
import cn from 'classnames';

import {useTouchDevice} from 'coreHooks';
import useCategory from 'coreHooks/categories/useCategory';

import Contentful from 'brand/app/contentful/components/Contentful';
import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Link from 'brandComponents/Link';

import {IInTheMoodForTileProps} from './IInTheMoodForTileProps';

// eslint-disable-next-line no-restricted-imports
import './InTheMoodForTile.scss';

const InTheMoodForTile = ({
	className,
	categoryId,
	image,
	hoverImg,
	title,
	active = false,
}: IInTheMoodForTileProps) => {
	const {managerRepository} = useGeneralProvider();
	const {setShowITMFBanner} = useCategoryContext(true) || {};
	const [hoveredImg, setHoveredImg] = useState(false);
	const isTouchDevice = useTouchDevice();
	const category = useCategory(categoryId);
	const targetUrl = category?.getCategoryUrl();

	const onMouseEnter = useCallback(() => {
		if (!isTouchDevice) {
			setHoveredImg(true);
		}
	}, []);

	const onMouseLeave = useCallback(() => {
		setHoveredImg(null);
	}, []);

	const onClick = useCallback(() => {
		setShowITMFBanner(true);
		managerRepository.getFlyoutsMgr().closeAllFlyouts();
	}, [targetUrl]);

	return (
		<div
			className={cn(className, 'itmf-tile', {'active': active})}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
		>
			<Link to={targetUrl} onClick={onClick}>
				<Contentful initialData={image} />
				{hoverImg && (
					<div
						className={cn(
							'itmf-tile__hover-image',
							{
								'hover-active': hoveredImg
							}
						)}
					>
						<Contentful initialData={hoverImg} />
					</div>
				)}
				<span className="itmf-tile__title">
					{title}
				</span>
			</Link>
		</div>
	);
};

export default InTheMoodForTile;
